import React from 'react';
import { Dropdown } from 'react-bootstrap';
import {
    ThreeDotsVertical,
    Printer,
    ArrowRightCircle,
    PencilSquare,
    Trash,
    CashCoin,
    Eye,
    ArrowLeftRight,
    CardChecklist,
    Percent
} from 'react-bootstrap-icons';

const StudentActionsDropdown = ({
    student,
    onPrintCard,
    onPreviewCard,
    onTransfer,
    onTransferWithinClass,
    onEdit,
    onDelete,
    onViewPayments,
    onViewStudent,
    onApplyEmployeeDiscount,
    userRole
}) => {
    return (
        <Dropdown align="end">
            <Dropdown.Toggle 
                variant="outline-secondary" 
                size="sm"
                className="btn-actions-dropdown"
                style={{ 
                    border: 'none',
                    backgroundColor: 'transparent',
                    color: '#6c757d',
                    boxShadow: 'none'
                }}
            >
                <ThreeDotsVertical size={16} />
            </Dropdown.Toggle>

            <Dropdown.Menu className="shadow-sm">
                {/* Voir l'élève */}
                <Dropdown.Item 
                    onClick={() => onViewStudent?.(student)}
                    className="d-flex align-items-center"
                >
                    <Eye size={16} className="me-2 text-info" />
                    Voir l'élève
                </Dropdown.Item>
                {/* Paiements (pour les comptables/admins) */}
                {(userRole === 'secretaire' || userRole === 'comptable_superieur' || userRole === 'accountant' || userRole === 'admin') && (
                    <Dropdown.Item
                        onClick={() => onViewPayments?.(student)}
                        className="d-flex align-items-center"
                    >
                        <CashCoin size={16} className="me-2 text-success" />
                        Voir paiements
                    </Dropdown.Item>
                )}

                {/* Réduction employé (pour comptables/admins) */}
                {(userRole === 'comptable_superieur' || userRole === 'accountant' || userRole === 'admin') && (
                    <Dropdown.Item
                        onClick={() => onApplyEmployeeDiscount?.(student)}
                        className="d-flex align-items-center"
                    >
                        <Percent size={16} className="me-2 text-warning" />
                        Réduction employé
                    </Dropdown.Item>
                )}

                <Dropdown.Divider />

                {/* Prévisualiser carte */}
                <Dropdown.Item
                    onClick={() => onPreviewCard?.(student)}
                    className="d-flex align-items-center"
                >
                    <CardChecklist size={16} className="me-2 text-primary" />
                    Prévisualiser la carte
                </Dropdown.Item>

                {/* Imprimer carte */}
                <Dropdown.Item
                    onClick={() => onPrintCard?.(student)}
                    className="d-flex align-items-center"
                >
                    <Printer size={16} className="me-2 text-success" />
                    Imprimer la carte
                </Dropdown.Item>

                {/* Transférer */}

                {(userRole === 'admin' || userRole === 'principal' || userRole === 'secretaire' || userRole === 'accountant' || userRole === 'comptable_superieur' || userRole === 'comptable') && (
                    <>
                        <Dropdown.Divider />
                        <Dropdown.Item 
                            onClick={() => onTransfer?.(student)}
                            className="d-flex align-items-center"
                        >
                            <ArrowRightCircle size={16} className="me-2 text-warning" />
                            Changer de classe
                        </Dropdown.Item>

                        <Dropdown.Item 
                            onClick={() => onTransferWithinClass?.(student)}
                            className="d-flex align-items-center"
                        >
                            <ArrowLeftRight size={16} className="me-2 text-info" />
                            Changer de série
                        </Dropdown.Item>

                        {/* Modifier */}
                        <Dropdown.Item 
                            onClick={() => onEdit?.(student)}
                            className="d-flex align-items-center"
                        >
                            <PencilSquare size={16} className="me-2 text-primary" />
                            Modifier
                        </Dropdown.Item>
                    </>
                )}
                
                {/* Supprimer - Seulement pour admin, principal, accountant et comptable_superieur */}
                {(userRole === 'admin' || userRole === 'principal' || userRole === 'accountant' || userRole === 'comptable_superieur') && (
                    <>
                        <Dropdown.Divider />
                        <Dropdown.Item 
                            onClick={() => onDelete?.(student)}
                            className="d-flex align-items-center text-danger"
                        >
                            <Trash size={16} className="me-2" />
                            Supprimer
                        </Dropdown.Item>
                    </>
                )}


                {/* Supprimer */}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default StudentActionsDropdown;